const routes = [
  {
    path: '/crmvlab',
    name: 'login',
    meta: {
      layout: 'login',
      isAuthRequired: false
    },
    component: () => import('@/views/user/Login.vue')
  }
  /* {
    path: '/signup',
    name: 'signup',
    meta: {
      isAuthRequired: false
    },
    component: () => import('@/views/user/SignUp.vue')
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    meta: {
      isAuthRequired: false
    },
    component: () => import('@/views/user/ForgotPassword.vue')
  },
  {
    path: '/passwordreset/:token(.*)',
    name: 'resetpassword',
    meta: {
      isAuthRequired: false
    },
    component: () => import('@/views/user/ResetPassword.vue')
  } */
]

export default routes
